module.exports = __webpack_public_path__ + "static/media/finish1.9a01e3ba.svg";